export default __webpack_public_path__ + "static/media/scrum.336820a7.png";